import mixpanel from "mixpanel-browser";

// Initialize Mixpanel with your token
export const initializeMixpanel = async () => {
  const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (mixpanelToken) {
    try {
      mixpanel.init(mixpanelToken, {
        debug: true,
        track_pageview: true,
        persistence: "localStorage",
      });
    } catch (error) {
      console.error("Mixpanel initialization failed:", error);
    }
  } else {
    console.error("Mixpanel token is missing.");
  }
};

// Track an event with properties
export const trackEvent = (event, properties) => {
  if (!event) {
    console.error("Event name is required");
    return;
  }
  mixpanel.track(event, properties);
};

// Track page views (you could set up specific tracking per page, etc.)
export const trackPageView = (pageName) => {
  mixpanel.track("page_view", { page: pageName });
};

// Identify user in Mixpanel
export const identifyUser = (userId, properties) => {
  mixpanel.identify(userId);
  mixpanel.people.set(properties); // Set user properties
};

// Set user profile properties (can be called after user signs up)
export const setUserProfile = (userId, properties) => {
  mixpanel.people.set(properties);
  mixpanel.identify(userId); // Make sure the user is identified
};

// Example of how you can set up event tracking with properties
export const trackUserSignUp = (userId, source) => {
  trackEvent("Sign_Up_Success", { user_id: userId, source: source });
};
